import axios from 'axios';
import { buildApiUrl } from '../config/apiConfig';
import { overlayGiftWalletOnCartItems, type CheckoutForfait } from '../pages/Checkout/checkoutPayload';
import type { CartItem } from '../contexts/CartContext';
import { getUserCredits } from '../services/api/proApi';

export function cartWalletMethodsChanged(before: CartItem[], after: CartItem[]): boolean {
  if (before.length !== after.length) return true;
  return after.some((item, index) => item.payment_method !== before[index]?.payment_method);
}

/** Marque forfait/crédits sur le panier déjà tarifé, après réclamation d’un cadeau. */
export async function applyGiftWalletToCartItems(
  userId: number,
  items: CartItem[]
): Promise<CartItem[]> {
  if (!userId || items.length === 0) return items;
  const token = localStorage.getItem('token') || '';
  const proIds = Array.from(new Set(items.map(item => item.proId)));
  const credits: Record<number, number> = {};
  let forfaits: CheckoutForfait[] = [];
  let forfaitsKnown = false;
  let creditsKnown = true;
  await Promise.all(
    proIds.map(async proId => {
      try {
        credits[proId] = await getUserCredits(userId, proId, token);
      } catch {
        creditsKnown = false;
      }
    })
  );
  try {
    const response = await axios.get(buildApiUrl(`/forfaits?user_id=${userId}`), {
      headers: { Authorization: `Bearer ${token}` },
    });
    forfaits = response.data.forfaits || [];
    forfaitsKnown = true;
  } catch {
    forfaits = [];
  }
  return overlayGiftWalletOnCartItems(items, forfaits, credits, {
    forfaitsKnown,
    creditsKnown,
  });
}
